




















































import Vue from 'vue'
import {
  Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ProductTemplate from '@/domain/product-template/entity/product-template.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ProductTemplateService from '@/domain/product-template/service/product-template.service';

@Component({
  components: {
    ModalComponent,
    ModalWarning,
  },
})
export default class ProductTemplateDuplicateModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  productTemplate!: ProductTemplate;

  @Prop({ required: true })
  businessUnitId!: string;

  @Prop({ required: true, default: [] })
  businessUnits!: BusinessUnit[];

  loading: boolean = false;

  selectedBusinessUnitId: string = '';

  warningModal: boolean = false;

  warningMessage = 'Algumas macros da observação são específicas para a unidade de negócio atual e pode não funcionar em outra unidade.'
    + ' Deseja seguir com a duplicação deste padrão de produto para outra unidade?';

  @Emit('cancel')
  private cancel(): void {
    this.selectedBusinessUnitId = '';
  }

  get options(): ModalOptions {
    return {
      title: 'Enviar configuração para outra unidade',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Salvar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 720,
      persistent: false,
      loadingOk: this.loading,
    }
  }

  confirmWarning(): void {
    this.loading = true;
    this.warningModal = false;
    this.checkProductTemplate();
    this.duplicateProductTemplate();
  }

  cancelWarning() {
    this.warningModal = false;
  }

  checkProductTemplate() {
    if (!this.productTemplate.id) {
      ProductTemplateService.createProductTemplate(this.businessUnitId, this.productTemplate)
        .then((response: any) => {
          this.productTemplate.id = response.id;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err));
    }
  }

  duplicateProductTemplate() {
    if (this.productTemplate.id) {
      ProductTemplateService.duplicateProductTemplate(
        this.selectedBusinessUnitId, this.productTemplate.id,
      ).then((response: any) => {
        VbSnackbarService.showSuccess('Padrão duplicado com sucesso');
      })
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
        .finally(() => {
          this.loading = false;
          this.selectedBusinessUnitId = '';
          this.cancel();
        });
    }
    if (!this.productTemplate.id) {
      VbSnackbarService.showError('Produto não encontrado');
    }
  }
}
